import { ActivatedRoute, Router } from "@angular/router";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxFormComponent,
} from "devextreme-angular";
import {
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";

import { AppConstant } from "src/app/app.const";
import { ComboBoxComponent } from "@progress/kendo-angular-dropdowns";
import { SalesService } from "./../sales.service";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import notify from "devextreme/ui/notify";
import { rangeValidator } from "./../../../../app/template/shared/validators/range.validator";
import { stepValidator } from "./../../../../app/template/shared/validators/steps.validator";
import { ApiCallStatusService } from "src/app/services/api-call-status.service";

declare var $: any;
// var isSubmit = true;
// var globalSalesOrderId = null;
@Component({
  selector: "app-normal-stock-order",
  templateUrl: "./normal-stock-order.component.html",
  styleUrls: ["./normal-stock-order.component.scss"],
})
export class NormalStockOrderComponent implements OnInit {
  normalStockForm: FormGroup;
  salesOrderId: any;
  customerId: any;
  loadingIndicator: boolean;
  customerTypelist: any[];
  tempCustomerTypeList: any[];
  loadingCustomerType: boolean;
  customerList: any[];
  loadingCustomer: boolean;
  tempCustomerList: any[];
  fileredCustomerList: any;
  loadingCustomerContact: boolean;
  customerContactList: any[];
  paymentTermValidationData: any;
  urgencyTypeList: any;
  allMaterials: any[];
  loadingMaterials: boolean;
  loadingItemTypeMaster: boolean;
  countryId: number;
  type: string;
  itemTypesList: any[];
  focalIdsList: any[];
  brandsList: any[];
  filterList: any[];
  itemCatalogList: any[];
  loadingItemCatalog: boolean;
  loadingFocal: boolean;
  loadingBrand: boolean;
  loadingIndex: boolean;
  indexList: any[];
  loadingFilters: boolean;
  lensSideList: any[];
  loadingRanges: boolean;
  // sphList: any[];
  // cylList: any[];
  // addfList: any[];
  uomsList: any[];
  loadingUoms: boolean;
  sizeList: any[];
  cylRangeList: any[];
  sphRangeList: any[];
  loadingCylRange: boolean;
  loadingSphRange: boolean;
  ItemCatalogData: any;
  availableQTY: any;
  stockLense: any;
  lineError: any;
  selectedCustomerContactEvent: any;
  @ViewChild("itemCatalogGroupId") itemCatalogDropdown: ComboBoxComponent;
  @ViewChild("stockLensGrid") stockLensGrid: DxDataGridComponent;
  @ViewChild("saveSwal") private saveSwal: SwalComponent;
  @ViewChild("gridScrollElement") gridScrollElement: ElementRef;
  @ViewChild("customerInformation") customerInformation: ElementRef;
  @ViewChild(DxFormComponent) form: DxFormComponent;
  @ViewChild("addItem") addItem: DxButtonComponent;
  focalId: any;
  itemCatalogGroupId: any;
  allRequiredErrorShow: boolean;
  total: number;
  salesOrderType: string;
  salesOrderData: any;
  selectedItemGroup: any;
  addfRangeList: any[];
  priceLabel: any;
  loadingPoNumber: boolean;
  holdSalesOrder: boolean;
  hideSubmitBtn: boolean;
  loadingAddfRange: boolean;
  appCons: AppConstant;
  addItemInverval: any;
  lensSideListForGrid: any;
  customerBranchId: any;
  isSubmit: boolean;
  constructor(
    private _salesService: SalesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private apiCallStatusSrvs:ApiCallStatusService
  ) {}
    isApiInProgress$ = this.apiCallStatusSrvs.isApiInProgress$;
  ngOnInit() {
    this.appCons = new AppConstant();
    this.selectedItemGroup = {};
    this._salesService.registerTabIndex();
    // reset
    this.customerTypelist = [];
    this.customerList = [];
    this.tempCustomerList = [];
    this.urgencyTypeList = [];
    this.lensSideListForGrid = [];
    // this.fileredCustomerList = [];
    this.customerContactList = [];
    this.allMaterials = [];
    this.itemTypesList = [];
    this.focalIdsList = [];
    this.brandsList = [];
    this.filterList = [];
    this.indexList = [];
    this.lensSideList = [];
    // this.sphList = [];
    // this.cylList = [];
    // this.addfList = [];
    this.uomsList = [];
    this.sizeList = [];
    this.cylRangeList = [];
    this.sphRangeList = [];
    this.addfRangeList = [];
    this.stockLense = [];
    this.selectedCustomerContactEvent = {};
    this.salesOrderId = 0;
    this.countryId = JSON.parse(localStorage.getItem("userData")).countryId;

    // end
    this.normalStockForm = new FormGroup({
      salesOrderId: new FormControl(
        this.salesOrderId ? this.salesOrderId : 0,
        []
      ),
      salesOrderDate: new FormControl(new Date(), []),
      customerId: new FormControl(this.customerId, []),
      customerContactId: new FormControl(0, []),
      salesOrderTypeId: new FormControl(1, []),
      patientName: new FormControl("", []),
      isOurLens: new FormControl(false, []),
      customerTypeId: new FormControl(1, [Validators.required]),
      customerBranchId: new FormControl(null, [Validators.required]),
      urgencyTypeId: new FormControl(2, [Validators.required]),
      ponumber: new FormControl("", []),
      partnerOrderNumber: new FormControl("", []),
      instruction: new FormControl("", []),
      isWaitforSample: new FormControl(false, []),
      remarks: new FormControl("", []),
      totalAmount: new FormControl(0, []),
      companyBranchId: new FormControl(0, []),
      createdByBranchId: new FormControl(0, []),
      // salesOrderDetail: new FormControl([], []),
      // salesOrderBulkMaster: new FormControl([], []),
      filtersInventory: new FormGroup({
        itemCatalogGroupId: new FormControl("", [Validators.required]),
        brandMasterId: new FormControl("", [Validators.required]),
        materialId: new FormControl(0, []),
        focalId: new FormControl(0, []),
        indexId: new FormControl(0, []),
        filterId: new FormControl(0, []),
        isTranspose: new FormControl(false, []),
        lensSideId: new FormControl(3, [Validators.required]),
        excludeBrandDiscount: new FormControl(false, []),
        isBarcodeSingleSide: new FormControl(false, []),
        mplDetailId: new FormControl(0, []),
        pricingTypeId: new FormControl(0, []),
        sideName: new FormControl("", []),
        sph: new FormControl(null, [Validators.required, 
          rangeValidator(-35, 30, "b"),
          stepValidator(0.25),
        ]),
        cyl: new FormControl(null, [
          rangeValidator(-15, 15, "b"),
          stepValidator(0.25),
        ]),
        addf: new FormControl(null, [
          rangeValidator(0.25, 4, "p"),
          stepValidator(0.25),
        ]),
        sphTranstose: new FormControl(null, [
          rangeValidator(-35, 30, "b"),
          stepValidator(0.25),
        ]),
        cylTranstose: new FormControl(null, [
          rangeValidator(-15, 15, "b"),
          stepValidator(0.25),
        ]),
        uomId: new FormControl("", [Validators.required]),
        axis: new FormControl("", [
          rangeValidator(0, 180, "p"),
          stepValidator(1),
        ]),
        qty: new FormControl("", [Validators.required]),
        unitPrice: new FormControl("", [Validators.required]),
        additionAmount: new FormControl("", []),
        itemSizeId: new FormControl("", [Validators.required]),
        size: new FormControl(0, []),
      }),
      addDateTime: new FormControl(new Date(), []),
      addUserId: new FormControl(
        JSON.parse(localStorage.getItem("userData")).id,
        []
      ),
      updateDateTime: new FormControl(new Date(), []),
      updateUserId: new FormControl(
        JSON.parse(localStorage.getItem("userData")).id,
        []
      ),
      active: new FormControl(true, []),
    });

    // CALL DROPDOWNS
    this.getAllCustomerTypes();
    // this.getAllLensSides();
    this.getAllCompanyBranchByCustomerId(
      JSON.parse(localStorage.getItem("selectedCustomerBranch")).customerId,
      JSON.parse(localStorage.getItem("userData")).id
    );
    this.getAllUrgencyTypes();
    this.getAllMaterials();
    this.getAllFocals();
    this.getAllFilters();
    this.getAllUoms();
    this.getAllLensSides();
    this.getSPH(-35, 35);
    this.getCYL(-15, 15);
    this.getADDF(0.25, 4);
    if (this.activatedRoute.snapshot.params.id) {
      this.salesOrderId = this.activatedRoute.snapshot.params.id;
      // globalSalesOrderId = this.activatedRoute.snapshot.params.id;
      this.salesOrderType =
        this.activatedRoute.snapshot.queryParamMap.get("salesOrderType");
      this.getAllSalesOrderBySalesOrderStockLensId(this.salesOrderId);
      this.type = "edit";
    } else {
      this.type = "add";
    }
    // this.normalStockForm
    //     .get("filtersInventory")
    //     .get("brandMasterId")
    //     .setValue(1);
    //   this.normalStockForm
    //     .get("filtersInventory")
    //     .get("materialId")
    //     .setValue(1);
    //   this.normalStockForm.get("filtersInventory").get("focalId").setValue(1);
    //   this.getStockIndex(1);
    //   this.normalStockForm.get("filtersInventory").get("indexId").setValue(27);
  }
  /**
   * @name getAllSalesOrderBySalesOrderStockLensId
   * @returns array of object
   * @description sales order request data by id
   */
  getAllSalesOrderBySalesOrderStockLensId(id) {
    this.loadingIndicator = true;
    this._salesService
      .getAllSalesOrderBySalesOrderStockLensId(id)
      .then((response) => {
        if (response.data.completed) {
          this.salesOrderData = response.data.payload;
          this.holdSalesOrder = this.salesOrderData.holdSalesOrder;
          if (this.holdSalesOrder) {
            const option = {
              width: 300,
              displayTime: 5000,
              message:
                "Stock order on hold please request stock issuance operater to unhold",
              type: "error",
            };
            notify(option);
          }
          this.salesOrderData.salesOrderDetail.salesOrderLens.map((item) => {
            item["sph"] = item.strSph;
            item["cyl"] = item.strCyl;
            item["addf"] = item.strAddf;
          });
          this.editData(response.data.payload);
          // this.filterClearValidate();
        }
        this.loadingIndicator = false;
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.log("err ", err);
      });
  }
  /**
   * @name isValidatePONumber
   * @param {string} poNumber
   * @param {number} customerId
   * @returns boolean
   * @description true false
   */
  isValidatePONumber(poNumber: string, customerId: number) {
    if (poNumber && customerId) {
      this.loadingPoNumber = true;
      this._salesService
        .isValidatePONumber(poNumber, customerId)
        .then((response) => {
          if (response.data.completed && response.data.payload == 1) {
            if (
              this.selectedCustomerContactEvent &&
              this.selectedCustomerContactEvent.providePO
            ) {
              this.normalStockForm.get("ponumber").setValue("");
            }
            const option = {
              width: 300,
              displayTime: 5000,
              message: "Po Number already exit!...",
              type: "warning",
            };
            notify(option);
          } else {
          }
          this.loadingPoNumber = false;
        })
        .catch((err) => {
          this.loadingPoNumber = false;
          console.log("err ", err);
        });
    }
  }

  /**
   * @name editData
   * @return edit data
   */
  editData(data: any) {
    this.normalStockForm.get("customerId").setValue(data.customerId);
    this.customerId = data.customerId;
    this.normalStockForm
      .get("customerBranchId")
      .setValue(data.customerBranchId);
    this.getCustomerContactName(data.customerBranchId);
    this.type = "edit";
    this.normalStockForm.get("salesOrderTypeId").setValue(1);
    this.normalStockForm.get("patientName").setValue(data.patientName);
    this.normalStockForm.get("isOurLens").setValue(data.isOurLens);
    this.normalStockForm.get("customerTypeId").setValue(data.customerTypeId);
    // this.filterCustomer(data.customerTypeId);

    this.normalStockForm.get("urgencyTypeId").setValue(data.urgencyTypeId);
    this.normalStockForm.get("ponumber").setValue(data.ponumber);
    this.normalStockForm
      .get("partnerOrderNumber")
      .setValue(data.partnerOrderNumber);
    this.normalStockForm.get("instruction").setValue(data.instruction);
    this.normalStockForm.get("isWaitforSample").setValue(data.isWaitforSample);
    this.normalStockForm.get("remarks").setValue(data.remarks);
    this.normalStockForm.get("totalAmount").setValue(data.totalAmount);
    this.normalStockForm.get("companyBranchId").setValue(data.companyBranchId);
    this.normalStockForm
      .get("createdByBranchId")
      .setValue(data.createdByBranchId);
    this.normalStockForm
      .get("customerContactId")
      .setValue(data.customerContactId);
    for (let i = 0; i < data.salesOrderDetail.salesOrderLens.length; i++) {
      this.stockLense.push(data.salesOrderDetail.salesOrderLens[i]);
    }
    this.stockLense.map((item, index) => {
      item["index"] = index;
      item["total"] = item.qty * item.unitPrice;
      item["uomname"] = item.uomName;
    });
    if (this.stockLense.length > 0) {
      const smoothScrollConfig = {
        block: "start",
        inline: "nearest",
        behavior: "smooth",
      };
      let el;
      setTimeout(() => {
        if (this.gridScrollElement) {
          el = this.gridScrollElement.nativeElement;
          el.scrollIntoView();
        }
      }, 1000);
    }
    this.getViewImtemCatalog();
    this.getGroupSize();
    this.type = "add";
  }
  /**
   * @name getAllCustomerTypes
   * @returns fetch customer types
   */
  getAllCustomerTypes() {
    this.loadingCustomerType = true;
    this.customerTypelist = [];
    this._salesService
      .getAllCustomerTypes()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.customerTypelist = list;
            this.tempCustomerTypeList = list;
            let filteredCustomerTypes = this.tempCustomerTypeList.filter(
              (x) => {
                return x.customerTypeId != 6;
              }
            );
            this.customerTypelist = filteredCustomerTypes;
          } else {
            if (response.data.payload.active) {
              this.customerTypelist = response.data.payload;
              this.tempCustomerTypeList = response.data.payload;
              let filteredCustomerTypes = this.tempCustomerTypeList.filter(
                (x) => {
                  return x.customerTypeId != 6;
                }
              );
              this.customerTypelist = filteredCustomerTypes;
            }
          }
        }
        this.loadingCustomerType = false;
      })
      .catch((error) => {
        this.loadingCustomerType = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }
  /**
   * @name onOpend
   * @returns void
   * @description remove element
   */
  onOpend() {
    let seen = {};
    $(".dx-scrollview-content .dx-item").each(() => {
      let txt = $(this).text();
      if (seen[txt]) {
        $(this).remove();
      } else {
        seen[txt] = true;
      }
    });
  }
  /**
   *@name  filterProvinces
   *@param countryId
   *@desc filters province list according to countryId
   */
  // filterCustomer(customerTypeId?: any, customerTypeEvent?: any) {
  //   this.customerList = [];
  //   if (this.tempCustomerList) {
  //     this.loadingCustomer = true;
  //     let filteredCustomers = this.tempCustomerList.filter((x) => {
  //       return x.customerTypeId === customerTypeId;
  //     });
  //     this.customerList = filteredCustomers;
  //     this.loadingCustomer = false;
  //   }
  // }

  /**
   * @name getAllCompanyBranchByCustomerId
   * @param {number} userId
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch Customers
   */
   getAllCompanyBranchByCustomerId(customerId: number, userId: number) {
    if (customerId && userId) {
      this.loadingCustomer = true;
      this._salesService
        .getAllCompanyBranchByCustomerId(customerId, userId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.customerList = list;
              this.tempCustomerList = list;
              if (!this.salesOrderId) {
                // this.filterCustomer(1);
              }
            } else {
              if (response.data.payload.active) {
                this.customerList = response.data.payload;
                this.tempCustomerList = response.data.payload;
                // if (!this.salesOrderId) {
                //   this.filterCustomer(1);
                // }
              }
            }
          }
          this.loadingCustomer = false;
        })
        .catch((error) => {
          this.loadingCustomer = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    }
  }

  /**
   * @name changeCustomerEvent
   * @return
   */
  changeCustomerEvent(customerBranchId: number) {
    if (customerBranchId) {
      let cBranchId = customerBranchId;
      if (this.stockLense.length > 0) {
        this.saveSwal.swalOptions = {
          icon: "error",
          titleText:
            "Change in Customer will reset the price and cannot be undone.",
          showConfirmButton: true,
          confirmButtonText: "Ok",
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          timer: null,
        };
        this.saveSwal.fire().then((res: any) => {
          console.log("Res", res);
          if (res && res.value) {
            // RESET ALL API CALL AGAIN
            this.normalStockForm.get("customerBranchId").setValue(cBranchId);
            this.getCustomerContactName(
              this.normalStockForm.get("customerBranchId").value
            );
            this.getViewImtemCatalog();
          } else {
            // set old customer id
            this.normalStockForm
              .get("customerBranchId")
              .setValue(this.customerBranchId);
            // this.getCustomerContactName(
            //   this.normalStockForm.get("customerBranchId").value
            // );
          }
        });
      } else {
        this.getCustomerContactName(
          this.normalStockForm.get("customerBranchId").value
        );
        this.getViewImtemCatalog();
      }
    }
  }
  /**
   * @name getCustomerContactName
   * @param {event} any
   * @returns customer list
   */
  getCustomerContactName(customerBranchId: any) {
    if (customerBranchId) {
      this.customerBranchId = customerBranchId;
      let selectedItem: any = {};

      const itemInterval = setInterval(() => {
        if (this.customerList.length > 0) {
          selectedItem = this.customerList.find(
            (item) => item.customerBranchId == customerBranchId
          );
          if (selectedItem && selectedItem.customerBranchId) {
            this.selectedCustomerContactEvent = selectedItem;
            this.customerId = selectedItem.customerId;
            // this.getCustomerBrandMasterByCategoryId(1, this.customerId);
            this.getCustomerBrandMaster(this.customerId, true, true, false);
            this.filterAllItemCatalogs();

            if (!this.salesOrderId) {
              this.validateCustomerPaymentTerm(this.customerId, this.normalStockForm.get("customerBranchId").value);
            }
            this.normalStockForm
              .get("customerId")
              .setValue(selectedItem.customerId);
            this.getAllCustomerContactByCustomerBranchId(
              selectedItem.customerBranchId
            );
            this.fileredCustomerList = this.customerList.find(
              (item) => item.customerBranchId == selectedItem.customerBranchId
            );
            this.checkBlockedCustomer(
              this.customerId,
              this.fileredCustomerList.paymentTypeId
            );
            // }
            if (this.selectedCustomerContactEvent.providePO) {
              this.normalStockForm
                .get("ponumber")
                .setValidators([Validators.required]);
            } else {
              this.normalStockForm.get("ponumber").clearValidators();
            }
            this.normalStockForm.get("ponumber").updateValueAndValidity();
          }
          clearInterval(itemInterval);
        }
      }, 200);
      if (this.type == "add") {
        this.normalStockForm.get("customerContactId").setValue(null);
        const itemCatalogDropDownInterval = setInterval(() => {
          if (this.itemCatalogDropdown) {
            this.itemCatalogDropdown.blur();
            this.itemCatalogDropdown.focus();
            clearInterval(itemCatalogDropDownInterval);
          }
        }, 10);
        // update price for customer change
        if (this.stockLense.length > 0) {
          this.stockLense.forEach(async (element) => {
            await this._salesService
              .getFnPrice(
                JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
                this.normalStockForm.get("customerBranchId").value,
                element.itemCatalogGroupId,
                element.focalId,
                element.brandMasterId,
                element.sph,
                element.cyl ? element.cyl : 0,
                element.addf ? element.addf : 0,
                false,
                JSON.parse(localStorage.getItem("selectedCustomerBranch"))
                  .companyBranchId
              )
              .then((response: any) => {
                if (response.data.completed && response.data.payload) {
                  if (response.data.payload.price == 0) {
                    const option = {
                      width: 300,
                      displayTime: 5000,
                      message: "Price not available for selected item!",
                      type: "warning",
                    };
                    notify(option);
                    return;
                  }
                  element["unitPrice"] = response.data.payload.price;
                } else {
                  const option = {
                    width: 300,
                    displayTime: 5000,
                    message: "No Price Found!",
                    type: "error",
                  };
                  notify(option);
                  console.error(response);
                }
              })
              .catch((error) => {
                this.loadingIndicator = false;
                const option = {
                  width: 300,
                  displayTime: 5000,
                  message: error.message,
                  type: "error",
                };
                console.log(error);
                notify(option);
              });
          });
        }
      }
    }
  }

   /**
   * @name validateCustomerPaymentTerm
   * @param {number} customerId
   * @returns Promise
   * @description customer validation limit
   */
    validateCustomerPaymentTerm(customerId: number, customerBranchId: any) {
      if (customerId && customerBranchId) {
        this._salesService
          .validateCustomerPaymentTerm(customerId, customerBranchId)
          .then((response) => {
            if (response.data.completed) {
              if (response.data.payload) {
                this.saveSwal.swalOptions = {
                  icon: "warning",
                  titleText: response.data.payload,
                  showConfirmButton: false,
                  confirmButtonText: "Reset",
                  showCancelButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  timer: null,
                };
                this.saveSwal.fire().then((res: any) => {
                  if (res && res.dismiss && res.dismiss == 'cancel') {
                    if (response.data.payload && response.data.payload.toLowerCase().includes('blocked')) {
                      this.normalStockForm.get('customerBranchId').setValue(null);
                      this.customerInformation.nativeElement.scrollIntoView();
                    }
                  }
                });
              }
            } else {
              const option = {
                width: 300,
                displayTime: 8000,
                message: response.data.message,
                type: "error",
              };
              notify(option);
            }
          })
          .catch((err) => {
            console.log("err ", err);
          });
      }
    }

  /**
   * @name resetAll
   * @return void
   */
  resetAll() {
    window.location.href = "/portal/sales/stock-sale-order/normal-stock-order";
    // this.router.navigate(['/portal/sales/stock-sale-order/normal-stock-order']);
    // this.resetAddGridItems();
    // this.normalStockForm.reset();
    // this.stockLense = [];
    // this.sizeList = [];
    // isSubmit = true;
    // this.setDefaultValue();
  }
  /**
   * @name checkBlockedCustomer
   * @description checks if user is blocked
   */
  checkBlockedCustomer(customerId: any, paymentTypeId: any) {
    if (customerId && paymentTypeId) {
      this._salesService
        .checkBlockedCustomer(customerId, paymentTypeId)
        .then((response: any) => {
          if (response.data.completed) {
            this.loadingIndicator = false;
            this.paymentTermValidationData = response.data.payload;
            if (this.paymentTermValidationData.message) {
              const option = {
                width: 300,
                displayTime: 5000,
                message: this.paymentTermValidationData.message,
                type: this.paymentTermValidationData.isBlock
                  ? "error"
                  : "warning",
              };
              notify(option);
            }
          }
        })
        .catch((error) => {
          this.loadingIndicator = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    }
  }
  /**
   * @name getAllCustomerContactByCustomerBranchId
   * @param {event} any
   * @returns customer list
   */
  getAllCustomerContactByCustomerBranchId(customerBranchId: any) {
    if (customerBranchId) {
      this.customerContactList = [];
      if (this.type == "add") {
        //  this.normalStockForm.get('customerContactId').setValue(null);
      }
      this.loadingCustomerContact = true;
      this._salesService
        .getAllCustomerContactByCustomerBranchId(customerBranchId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.customerContactList = list;
            } else {
              this.customerContactList = response.data.payload;
            }
            let filterList = this.customerContactList.filter((item) => {
              return item.customerBranchId == customerBranchId;
            });
            this.customerContactList = filterList;
          }
          this.loadingCustomerContact = false;
        })
        .catch((error) => {
          this.loadingCustomerContact = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    }
  }
  getAllUrgencyTypes() {
    this.loadingIndicator = true;
    this._salesService
      .getAllUrgencyTypes()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.urgencyTypeList = list;
          } else {
            if (response.data.payload.active) {
              this.urgencyTypeList = response.data.payload;
            }
          }
        }
        this.loadingIndicator = false;
      })
      .catch((error) => {
        this.loadingIndicator = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }
  /**
   * @name getAllMaterials
   * @returns Promise
   * @description fetch all item
   */
  getAllMaterials() {
    this.loadingMaterials = true;
    this._salesService
      .getAllMaterials()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.allMaterials = list;
            this.normalStockForm
              .get("filtersInventory")
              .get("materialId")
              .setValue(this.allMaterials[0].materialId);
            this.getStockIndex(this.allMaterials[0].materialId);
          } else {
            if (response.data.payload.active) {
              this.allMaterials = response.data.payload;
              this.normalStockForm
                .get("filtersInventory")
                .get("materialId")
                .setValue(this.allMaterials[0].materialId);
              this.getStockIndex(this.allMaterials[0].materialId);
            }
          }
          this.loadingMaterials = false;
        }
      })
      .catch((error) => {
        this.loadingMaterials = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }

  /**
   * @name getAllFocals
   * @returns Promise
   * @description fetch all item
   */
  getAllFocals() {
    this.loadingFocal = true;
    this._salesService
      .getAllFocals()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.focalIdsList = list;
            this.normalStockForm
              .get("filtersInventory")
              .get("focalId")
              .setValue(this.focalIdsList[0].focalId);
          } else {
            if (response.data.payload.active) {
              this.focalIdsList = response.data.payload;
              this.normalStockForm
                .get("filtersInventory")
                .get("focalId")
                .setValue(this.focalIdsList[0].focalId);
            }
          }
          this.loadingFocal = false;
        }
      })
      .catch((error) => {
        this.loadingFocal = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }
/**
   * @name getCustomerBrandMasterByCategoryId
   * @params {number} itemCategoryId
   * @param {number} customerId
   * @returns Promise
   * @description fetch Brand List
   */
  //  getCustomerBrandMasterByCategoryId(itemCategoryId: number, customerId: number) {
  //   if (itemCategoryId && customerId) {
  //   this.loadingBrand = true;
  //   this._salesService
  //   .getCustomerBrandMasterByCategoryId(itemCategoryId, customerId)
  //     .then((response) => {
  //       if (response.data.completed) {
  //         if (response.data.payload.length > 0) {
  //           const list = [];
  //           response.data.payload.forEach((element) => {
  //             if (element.active) {
  //               list.push(element);
  //             }
  //           });
  //           this.brandsList = list;
            
  //           this.normalStockForm
  //             .get("filtersInventory")
  //             .get("brandMasterId")
  //             .setValue(this.brandsList[0].brandMasterId);
  //         } else {
  //           if (response.data.payload.active) {
  //             this.brandsList = response.data.payload;
  //             this.normalStockForm
  //               .get("filtersInventory")
  //               .get("brandMasterId")
  //               .setValue(this.brandsList[0].brandMasterId);
  //           }
  //         }
  //         this.loadingBrand = false;
  //         this.filterAllItemCatalogs();
  //       }
  //     })
  //     .catch((error) => {
  //       this.loadingBrand = false;
  //       const option = {
  //         width: 300,
  //         displayTime: 5000,
  //         message: error.message,
  //         type: "error",
  //       };
  //       console.log(error);
  //       notify(option);
  //     });
  //   }
  // }
  getCustomerBrandMaster(customerId: number, isRx: boolean,isStock: boolean, isOther: boolean) {
    if (customerId) {
     this._salesService
     .getCustomerBrandMaster(customerId, isRx, isStock, isOther)
     .then((response) => {
       if (response.data.completed) {
         if (response.data.payload.length > 0) {
           const list = [];
           response.data.payload.forEach((element: any) => {
             if (element.active) {
               list.push(element);
             }
           });
           this.brandsList = list;
         } else {
           if (response.data.payload.active) {
             this.brandsList = response.data.payload;
           }
         }
       }
       this.loadingIndicator = false;
     })
     .catch((err) => {
       this.loadingIndicator = false;
       console.error("Error:  ", err);
     });
    }
  
 }

  getViewImtemCatalog() {
    // if (!this.salesOrderId) {
    this.filterAllItemCatalogs(this.type);
    // }
  }
  /**
   * @name getStockIndex
   * @param {number} materialId
   * @method GET
   * @return Promise
   */
  getStockIndex(materialId: number) {
    if (materialId) {
      this.indexList = [];
      this.loadingIndex = true;
      this._salesService
        .getStockIndex(materialId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.indexList = list;
              // this.normalStockForm.get("filtersInventory").get("indexId").setValue(this.indexList[0].indexId);
            } else {
              if (response.data.payload.active) {
                this.indexList = response.data.payload;
                // this.normalStockForm.get("filtersInventory").get("indexId").setValue(this.indexList[0].indexId);
              }
            }
            this.loadingIndex = false;
            if (!this.salesOrderId) {
              this.filterAllItemCatalogs(this.type);
            }
          }
        })
        .catch((error) => {
          this.loadingIndex = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    } else {
      this.indexList = [];
    }
  }
  /**
   * @name getAllFilters
   * @returns Promise
   * @description fetch all item
   */
  getAllFilters() {
    this.loadingFilters = true;
    this._salesService
      .getAllFilters()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.filterList = list;
          } else {
            if (response.data.payload.active) {
              this.filterList = response.data.payload;
            }
          }
          this.loadingFilters = false;
        }
      })
      .catch((error) => {
        this.loadingFilters = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }
  /**
   * @name filterAllItemCatalogs
   * @param {event}  itemTypeMasterId
   * @param {number} brandMasterId
   * @return subBrandsList
   * @description fetch data by id
   */
  filterAllItemCatalogs(type?: string, subBrandMasterId?: number) {
    if (
      this.normalStockForm.get("filtersInventory").get("brandMasterId").value
    ) {
      const payload = {
        materialId: this.normalStockForm
          .get("filtersInventory")
          .get("materialId").value
          ? this.normalStockForm.get("filtersInventory").get("materialId").value
          : 0,
        focalId: this.normalStockForm.get("filtersInventory").get("focalId")
          .value
          ? this.normalStockForm.get("filtersInventory").get("focalId").value
          : 0,
        brandMasterId: this.normalStockForm
          .get("filtersInventory")
          .get("brandMasterId").value
          ? this.normalStockForm.get("filtersInventory").get("brandMasterId")
              .value
          : 0,
        filterId: this.normalStockForm.get("filtersInventory").get("filterId")
          .value
          ? this.normalStockForm.get("filtersInventory").get("filterId").value
          : 0,
        indexId: this.normalStockForm.get("filtersInventory").get("indexId")
          .value
          ? this.normalStockForm.get("filtersInventory").get("indexId").value
          : 0,
          customerId: this.customerId
      };
      this.itemCatalogList = [];

      if (type == "add" && !this.salesOrderId) {
        this.normalStockForm
          .get("filtersInventory")
          .get("itemCatalogGroupId")
          .setValue("");
      }
      this.loadingItemCatalog = true;
      console.log(payload);
      //getAllItemCatalogGroup
      this._salesService
        .getAllItemCatalogGroupByCustomerId(payload)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.itemCatalogList = list;
              this.itemCatalogList.map((item, index) => {
                item["itemIndex"] = index + 1;
              });
            } else {
              if (response.data.payload.active) {
                this.itemCatalogList = response.data.payload;
                this.itemCatalogList.map((item, index) => {
                  item["itemIndex"] = index + 1;
                });
              }
            }
          } else {
            console.error(
              "getAllItemCatalogGroup Line 945: ",
              response.data.message
            );
            // const option = {
            //   width: 300,
            //   displayTime: 3000,
            //   message: response.data.message,
            //   type: "error",
            // };
            // notify(option);
          }
          this.loadingItemCatalog = false;
        })
        .catch((error) => {
          this.loadingItemCatalog = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: error.message,
            type: "error",
          };
          notify(option);
        });
    }
  }

  /**
   * @name selectedItemCatalogGroup
   * @param {number} itemCatalogGroupId
   */
  selectedItemCatalogGroup(itemCatalogGroupId: number) {
    if (
      this.salesOrderId &&
      JSON.parse(localStorage.getItem("selectedCustomerBranch"))
        .companyBranchId !== this.salesOrderData.companyBranchId
    ) {
      const option = {
        width: 300,
        displayTime: 3000,
        message: "Order is another branch...",
        type: "warning",
      };
      notify(option);
      return;
    }
    if (itemCatalogGroupId) {
      // this.normalStockForm.get('filtersInventory').reset();
      this.normalStockForm.get("filtersInventory").get("sph").setValue(null);
      // this.getStockSPH(itemCatalogGroupId);
      const itemInterval = setInterval(() => {
        if (this.itemCatalogList.length > 0) {
          const item = this.itemCatalogList.find(
            (i) => i.itemCatalogGroupId == itemCatalogGroupId
          );
          this.selectedItemGroup = item;
          this.focalId = item.focalId;
          this.getAllLensSidesByFocalId(this.focalId);
          this.normalStockForm.get("filtersInventory").get("qty").setValue(1);
          // if (this.selectedItemGroup.focalId == 1 || this.selectedItemGroup.focalId == 3) {
          //   this.normalStockForm.get('filtersInventory').get("axis").setValidators([rangeValidator(1, 180, "p"),
          //   stepValidator(1), Validators.required]);
          //   this.normalStockForm.get('filtersInventory').get("axis").updateValueAndValidity();
          // } else {
          //   this.normalStockForm.get('filtersInventory').get("axis").setValidators([rangeValidator(1, 180, "p"),
          //   stepValidator(1)]);
          //   this.normalStockForm.get('filtersInventory').get("axis").updateValueAndValidity();
          // }
          if (
            this.selectedItemGroup &&
            this.selectedItemGroup.itemTypeMasterId == 2 &&
            this.selectedItemGroup.focalId == 1
          ) {
            this.normalStockForm
              .get("filtersInventory")
              .get("cyl")
              .setValidators([Validators.required]);
            this.normalStockForm
              .get("filtersInventory")
              .get("cyl")
              .updateValueAndValidity();
            this.normalStockForm
              .get("filtersInventory")
              .get("addf")
              .setValue(null);
            this.normalStockForm
              .get("filtersInventory")
              .get("addf")
              .clearValidators();
            this.normalStockForm
              .get("filtersInventory")
              .get("addf")
              .updateValueAndValidity();
            this.normalStockForm
              .get("filtersInventory")
              .get("sph")
              .setValue("0.00");
            // this.getCylAndAdd();
            this.normalStockForm
              .get("filtersInventory")
              .get("cyl")
              .setValue("0.00");
          }
          if (
            this.selectedItemGroup &&
            this.selectedItemGroup.itemTypeMasterId == 2 &&
            (this.selectedItemGroup.focalId == 2 ||
              this.selectedItemGroup.focalId == 3)
          ) {
            this.normalStockForm
              .get("filtersInventory")
              .get("cyl")
              .clearValidators();
            this.normalStockForm
              .get("filtersInventory")
              .get("cyl")
              .updateValueAndValidity();

            this.normalStockForm
              .get("filtersInventory")
              .get("cyl")
              .setValue(null);
            this.normalStockForm
              .get("filtersInventory")
              .get("addf")
              .setValidators([Validators.required]);
            this.normalStockForm
              .get("filtersInventory")
              .get("addf")
              .updateValueAndValidity();
            this.normalStockForm
              .get("filtersInventory")
              .get("sph")
              .setValue("0.00");
          }

          this.getGroupSize();
          this.getFnPrice(
            this.normalStockForm.get("customerBranchId").value,
            itemCatalogGroupId,
            this.normalStockForm.get("filtersInventory").get("sph").value,
            this.normalStockForm.get("filtersInventory").get("cyl").value,
            this.normalStockForm.get("filtersInventory").get("addf").value
          );
          clearInterval(itemInterval);
          if (this.isTranspose) {
            this.normalStockForm
              .get("filtersInventory")
              .get("isTranspose")
              .setValue(false);
          }
        }
      }, 1000);
    } else {
      this.lensSideList = [];
    }
  }
  /**
   * @name getAllLensSidesByFocalId
   * @param {number} focalId
   * @returns Promise
   * @description fetch lense side
   */
  getAllLensSidesByFocalId(focalId: number) {
    this.loadingIndicator = true;
    this._salesService
      .getAllLensSidesByFocalId(focalId)
      .then((response: any) => {
        if (response.data.completed && response.data.payload.length > 0) {
          this.loadingIndicator = false;
          this.lensSideList = response.data.payload;
          if (
            this.selectedItemGroup.focalId == 2 ||
            this.selectedItemGroup.focalId == 3
          ) {
            this.normalStockForm
              .get("filtersInventory")
              .get("lensSideId")
              .setValue(2);
          } else {
            this.normalStockForm
              .get("filtersInventory")
              .get("lensSideId")
              .setValue(3);
          }
        } else {
          this.loadingIndicator = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: "Lense not found...",
            type: "error",
          };
          notify(option);
          console.error(response);
        }
      })
      .catch((error) => {
        this.loadingIndicator = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }

  /**
   * @name getAllLensSidesByFocalId
   * @param {number} focalId
   * @returns Promise
   * @description fetch lense side
   */
  getAllLensSides() {
    this.loadingIndicator = true;
    this._salesService
      .getAllLensSides()
      .then((response: any) => {
        if (response.data.completed && response.data.payload.length > 0) {
          this.loadingIndicator = false;
          this.lensSideListForGrid = response.data.payload;
        } else {
          this.loadingIndicator = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: "Lense not found...",
            type: "error",
          };
          notify(option);
          console.error(response);
        }
      })
      .catch((error) => {
        this.loadingIndicator = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }

  /**
   * @name getAllUoms
   * @reurn umo list
   */
  getAllUoms() {
    this.loadingUoms = true;
    this._salesService
      .getAllUoms()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.uomsList = list;
          } else {
            if (response.data.payload.active) {
              this.uomsList = response.data.payload;
            }
          }
        }
        this.loadingUoms = false;
      })
      .catch((error) => {
        this.loadingUoms = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }
  /**
   * @name getStockSPH
   * @params {number} itemCatalogGroupId
   * @returns Promise
   * @description fetch all item
   */
  getStockSPH(itemCatalogGroupId: number) {
    if (itemCatalogGroupId) {
      // this.normalStockForm.get('filtersInventory').get('sph').setValue(null);
      this.loadingSphRange = true;
      this._salesService
        .getStockSPH(itemCatalogGroupId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              this.sphRangeList = response.data.payload;
              // const list = [];
              // response.data.payload.forEach((element) => {
              //   if (element.active) {
              //     list.push(element);
              //   }
              // });
              // this.sphRangeList = list;
            } else {
              if (response.data.payload.active) {
                this.sphRangeList = response.data.payload;
              }
            }
            this.loadingRanges = false;
          }
        })
        .catch((error) => {
          this.loadingSphRange = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    }
  }
  /**
   * @name getStockCYL
   * @param {number} itemCatalogGroupId
   * @param {number} sph
   * @returns sph range
   * @memberof salesService
   */
  getStockCYL(itemCatalogGroupId: number, sph: any) {
    if (itemCatalogGroupId && (sph || sph == 0)) {
      this.loadingCylRange = true;
      this.normalStockForm.get("filtersInventory").get("cyl").setValue("");
      this.cylRangeList = [];
      this._salesService
        .getStockCYL(itemCatalogGroupId, sph)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              this.cylRangeList = response.data.payload;
              // const list = [];
              // response.data.payload.forEach((element) => {
              //   if (element.active) {
              //     list.push(element);
              //   }
              // });
              // this.cylRangeList = list;
            } else {
              if (response.data.payload.active) {
                this.cylRangeList = response.data.payload;
              }
            }
            this.loadingCylRange = false;
          }
        })
        .catch((error) => {
          this.loadingCylRange = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    } else {
      this.normalStockForm.get("filtersInventory").get("cyl").setValue("");
      this.cylRangeList = [];
    }
  }

  /**
   * @name getStockADD
   * @param {number} itemCatalogGroupId
   * @param {number} sph
   * @returns sph range
   * @memberof salesService
   */
  getStockADD(itemCatalogGroupId: number, sph: any) {
    if (itemCatalogGroupId && (sph || sph == 0)) {
      this.loadingCylRange = true;
      this.normalStockForm.get("filtersInventory").get("addf").setValue("");
      this.addfRangeList = [];
      this._salesService
        .getStockADD(itemCatalogGroupId, sph)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              this.addfRangeList = response.data.payload;
              // const list = [];
              // response.data.payload.forEach((element) => {
              //   if (element.active) {
              //     list.push(element);
              //   }
              // });
              // this.addfRangeList = list;
            } else {
              if (response.data.payload.active) {
                this.addfRangeList = response.data.payload;
              }
            }
            this.loadingCylRange = false;
          }
        })
        .catch((error) => {
          this.loadingCylRange = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    } else {
      this.normalStockForm.get("filtersInventory").get("addf").setValue("");
      this.addfRangeList = [];
    }
  }

  getCylAndAdd() {
    if (
      this.selectedItemGroup &&
      this.selectedItemGroup.focalId == 1 &&
      this.selectedItemGroup.itemTypeMasterId == 2
    ) {
      // this.getStockCYL(this.normalStockForm.get('filtersInventory').get('itemCatalogGroupId').value, this.normalStockForm.get('filtersInventory').get('sph').value);
      this.normalStockForm.get("filtersInventory").get("cyl").setValue(null);
      this.getCYL(-15, 15);
    }
    if (
      this.selectedItemGroup &&
      this.selectedItemGroup.itemTypeMasterId == 2 &&
      (this.selectedItemGroup.focalId == 2 ||
        this.selectedItemGroup.focalId == 3)
    ) {
      // this.getStockADD(this.normalStockForm.get('filtersInventory').get('itemCatalogGroupId').value, this.normalStockForm.get('filtersInventory').get('sph').value);
      this.normalStockForm.get("filtersInventory").get("addf").setValue(null);
      this.getADDF(0.25, 4);
    }
  }
  /**
   * @name getSPH
   * @param {number} range1
   * @param {number} range2
   * @returns sph range
   * @memberof salesService
   */
    getSPH(range1: number, range2: number) {
      this.loadingSphRange = true;
      this._salesService
        .getSPH(range1, range2)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.sphRangeList = list;
            } else {
              if (response.data.payload.active) {
                this.sphRangeList = response.data.payload;
              }
            }
            this.loadingSphRange = false;
          }
        })
        .catch((err) => {
          this.loadingSphRange = false;
          console.log("err ", err);
        });
    }
  /**
   * @name getCYL
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  getCYL(range1: number, range2: number) {
    this.loadingCylRange = true;
    this._salesService
      .getCYL(range1, range2)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.cylRangeList = list;
          } else {
            if (response.data.payload.active) {
              this.cylRangeList = response.data.payload;
            }
          }
          this.loadingCylRange = false;
        }
      })
      .catch((err) => {
        this.loadingCylRange = false;
        console.error("Line: 5009 ", err);
      });
  }
  /**
   * @name getADDF
   * @param {number} range1
   * @param {number} range2
   * @returns addf range
   * @memberof salesService
   */
  getADDF(range1: number, range2: number) {
    this.loadingAddfRange = true;
    this._salesService
      .getADDF(range1, range2)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.addfRangeList = list;
          } else {
            if (response.data.payload.active) {
              this.addfRangeList = response.data.payload;
            }
          }
          this.loadingAddfRange = false;
        }
      })
      .catch((error) => {
        this.loadingAddfRange = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }
  /**
   * @name getItemCatalog
   * @param {number} itemCatalogGroupId
   * @param {number} itemSizeId
   * @returns itemCatalog
   * @memberof salesService
   */
  // getItemCatalog(itemCatalogGroupId: number, itemSizeId: number) {
  //   if (itemCatalogGroupId && itemSizeId) {
  //     this.loadingIndicator = true;
  //     this._salesService
  //       .getItemCatalog(itemCatalogGroupId, itemSizeId)
  //       .then((response) => {
  //         if (response.data.completed) {
  //           if (response.data.payload) {
  //             this.ItemCatalogData = response.data.payload;
  //             this.getFnPrice(
  //               this.normalStockForm.get("customerBranchId").value,
  //               itemCatalogGroupId,
  //               this.normalStockForm.get("filtersInventory").get("sph").value,
  //               this.normalStockForm.get("filtersInventory").get("cyl").value,
  //               this.normalStockForm.get("filtersInventory").get("addf").value
  //             );
  //           } else {
  //             const option = {
  //               width: 300,
  //               displayTime: 5000,
  //               message: response.data.message,
  //               type: "error",
  //             };
  //             notify(option);
  //           }
  //           this.loadingIndicator = false;
  //         }
  //       })
  //       .catch((error) => {
  //         this.loadingIndicator = false;
  //         const option = {
  //           width: 300,
  //           displayTime: 5000,
  //           message: error.message,
  //           type: "error",
  //         };
  //         console.log(error);
  //         notify(option);
  //       });
  //   } else {
  //     this.ItemCatalogData = null;
  //   }
  // }

  /**
   * @name ValueCalculateToTranstose
   * @params {number} sph
   * @params {number} cyl
   * @return void
   */

  ValueCalculateToTranstose(sph: any, cyl: any) {
    if ((sph || sph == 0) && (cyl || cyl == 0)) {
      if (
        this.normalStockForm.get("filtersInventory").get("isTranspose").value
      ) {
        const val: any = parseFloat(sph) + parseFloat(cyl);
        const val2: any = parseFloat(cyl) * -1;
        this.normalStockForm
          .get("filtersInventory")
          .get("sphTranstose")
          .setValue(val);
        // this.check_number(val) ? '-' : '+' + parseFloat(val).toFixed(2)
        this.normalStockForm
          .get("filtersInventory")
          .get("cylTranstose")
          .setValue(parseFloat(val2));
        this.getFnPrice(
          this.normalStockForm.get("customerBranchId").value,
          this.normalStockForm.get("filtersInventory").get("itemCatalogGroupId")
            .value,
          this.normalStockForm.get("filtersInventory").get("sph").value,
          this.normalStockForm.get("filtersInventory").get("cyl").value,
          this.normalStockForm.get("filtersInventory").get("addf").value
        );
        // this.getItemCatalog(
        //   this.normalStockForm.get("filtersInventory").get("itemCatalogGroupId")
        //     .value,
        //   this.normalStockForm.get("filtersInventory").get("itemSizeId").value
        // );
      }
    }
    // let isAxix = false;
    // if (this.normalStockForm.get("filtersInventory").get("axis").value > 0) {
    //   if (this.normalStockForm.get("filtersInventory").get("axis").value > 90) {
    //     let axis = this.normalStockForm.get("filtersInventory").get("axis")
    //       .value;
    //     isAxix = true;
    //     this.normalStockForm
    //       .get("filtersInventory")
    //       .get("axis")
    //       .setValue(axis - 90);
    //   }
    //   if (
    //     this.normalStockForm.get("filtersInventory").get("axis").value < 90 &&
    //     !isAxix
    //   ) {
    //     let axis = this.normalStockForm.get("filtersInventory").get("axis")
    //       .value;
    //     this.normalStockForm
    //       .get("filtersInventory")
    //       .get("axis")
    //       .setValue(axis + 90);
    //   }
    // }
  }

  /**
   * @name check_number
   * @param num_value
   * @returns bool
   */
  check_number(num_value) {
    if (num_value >= 0) {
      return false;
    } else {
      return true;
    }
  }
  /**
   * @name isTranspose
   * @return boolean
   */
  get isTranspose() {
    if (this.normalStockForm.get("filtersInventory").get("cyl").value > 0) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * @name resetTranstose
   * @return void
   */
  resetTranstose() {
    if (this.isTranspose) {
      this.normalStockForm
        .get("filtersInventory")
        .get("isTranspose")
        .setValue(false);
    }
  }

  // /**
  //  * @name setItemCatalogId
  //  * @param {number} itemSizeId
  //  */
  // setItemCatalogId(itemSizeValue: number) {
  //   if (this.sizeList.length > 0 && itemSizeValue) {
  //     const item = this.sizeList.find((o) => o.itemSizeValue == itemSizeValue);
  //     if (item) {
  //       this.itemCatalogGroupId = item.itemCatalogGroupId;
  //     }
  //   }
  // }
  /**
   * @name changeSize
   * @return void
   */
  // changeSize(event?: any) {
  //   if (event && event.event) {
  //     this.getItemCatalog(
  //       this.normalStockForm.get("filtersInventory").get("itemCatalogGroupId")
  //         .value,
  //       this.normalStockForm.get("filtersInventory").get("itemSizeId").value
  //     );
  //   }
  // }
  /**
   * @name getGroupSize
   * @params {numbers}, lensSideId, sph, cyl, addf, brandMasterId, subBrandMasterId, focalId, colorMasterId, materialId, corridorId, itemTypeMasterId, filterBrandId, filterId, indexId
   * @return Size List
   */
  getGroupSize() {
    this.sizeList = [];
    const sph = this.normalStockForm.get("filtersInventory").get("sph").value;
    const cyl = this.normalStockForm.get("filtersInventory").get("cyl").value;
    const addf = this.normalStockForm.get("filtersInventory").get("addf").value;
    if (
      (sph || sph == 0) &&
      (cyl == 0 || cyl || addf == 0 || addf) &&
      this.normalStockForm.get("filtersInventory").get("itemCatalogGroupId")
        .value
    ) {
      let itemCatalogGroupId = this.normalStockForm
        .get("filtersInventory")
        .get("itemCatalogGroupId").value;
      let item = this.itemCatalogList.find(
        (i) => i.itemCatalogGroupId == itemCatalogGroupId
      );
      if (item) {
        const payload = {
          sph: sph ? sph : 0,
          cyl: cyl ? cyl : 0,
          addf: addf ? addf : 0,
          focalId: item.focalId,
          itemCatalogGroupId: itemCatalogGroupId,
        };
        this._salesService
          .getGroupSize(payload)
          .then((response: any) => {
            if (response.data.completed && response.data.payload.length > 0) {
              this.loadingIndicator = false;
              this.sizeList = response.data.payload;
              if (!this.salesOrderId) {
                this.normalStockForm
                  .get("filtersInventory")
                  .get("itemSizeId")
                  .setValue(this.sizeList[0].itemSizeId);
              }

              // this.itemCatalogGroupId = this.sizeList[0].itemCatalogGroupId;
              // this.getItemCatalog(
              //   this.normalStockForm
              //     .get("filtersInventory")
              //     .get("itemCatalogGroupId").value,
              //   this.normalStockForm.get("filtersInventory").get("itemSizeId")
              //     .value
              // );
              //this.getFnPrice(this.normalStockForm.get('customerBranchId').value, this.sizeList[0].itemCatalogGroupId, this.normalStockForm.get('filtersInventory').get('sph').value, this.normalStockForm.get('filtersInventory').get('cyl').value, this.normalStockForm.get('filtersInventory').get('addf').value);
            } else {
              this.normalStockForm
                .get("filtersInventory")
                .get("itemSizeId")
                .setValue(null);
              this.normalStockForm
                .get("filtersInventory")
                .get("unitPrice")
                .setValue(null);
              this.priceLabel = "";
              this.normalStockForm
                .get("filtersInventory")
                .get("uomId")
                .setValue(null);
              this.loadingIndicator = false;
              const option = {
                width: 300,
                displayTime: 3000,
                message: "Item not found...",
                type: "error",
              };
              notify(option);
              console.error(response);
            }
          })
          .catch((error) => {
            this.loadingIndicator = false;
            const option = {
              width: 300,
              displayTime: 3000,
              message: error.message,
              type: "error",
            };
            notify(option);
          });
      }
    }
  }

  /**
   * @name getFnPrice
   * @description price of item
   */
  getFnPrice(
    customerBranchId: number,
    itemCatalogGroupId: number,
    sph: any,
    cyl: any,
    addf: any
  ) {
    console.log(event);

    //this.isTranspose &&
    if (
      customerBranchId &&
      itemCatalogGroupId &&
      (sph || sph == 0) &&
      (cyl || cyl == 0 || addf || addf == 0)
    ) {
      let isCyl = false;
      let isAdd = false;
      // let index = this.normalStockForm
      // .get("filtersInventory")
      // .get("itemCatalogGroupId").value;
      // const item = this.itemCatalogList.find(
      //   (obj) => obj.itemIndex == index
      // );
      // console.log('item', item)
      let customerId = this.customerList.find(
        (obj) => obj.customerBranchId == customerBranchId
      ).customerId;
      if (
        this.selectedItemGroup.itemTypeMasterId == 2 &&
        this.selectedItemGroup.focalId == 1
      ) {
        isCyl = true;
      }
      if (
        this.selectedItemGroup.itemTypeMasterId == 2 &&
        (this.selectedItemGroup.focalId == 2 ||
          this.selectedItemGroup.focalId == 3)
      ) {
        isAdd = true;
      }
      if (
        (customerBranchId &&
          itemCatalogGroupId &&
          (sph || sph == 0) &&
          isCyl &&
          (cyl || cyl == 0)) ||
        (isAdd && (addf || addf == 0))
      ) {
        // this.getGroupSize();
        this.normalStockForm
          .get("filtersInventory")
          .get("unitPrice")
          .setValue("");
        this.priceLabel = "";
        this._salesService
          .getFnPrice(
            JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
            customerId,
            itemCatalogGroupId,
            this.selectedItemGroup.focalId,
            this.selectedItemGroup.brandMasterId,
            sph,
            cyl ? cyl : 0,
            addf ? addf : 0,
            this.selectedItemGroup.isBarcodeSingleSide
              ? this.selectedItemGroup.isBarcodeSingleSide
              : false,
            JSON.parse(localStorage.getItem("selectedCustomerBranch"))
              .companyBranchId
          )
          .then((response: any) => {
            if (response.data.completed && response.data.payload) {
              if (response.data.payload.price == 0) {
                const option = {
                  width: 300,
                  displayTime: 5000,
                  message: "Price not available for selected item!",
                  type: "warning",
                };
                notify(option);
                return;
              }
              this.priceLabel = response.data.payload.priceTypeName;
              this.normalStockForm
                .get("filtersInventory")
                .get("unitPrice")
                .setValue(response.data.payload.price);
              this.normalStockForm
                .get("filtersInventory")
                .get("uomId")
                .setValue(response.data.payload.uomId);
              this.normalStockForm
                .get("filtersInventory")
                .get("excludeBrandDiscount")
                .setValue(response.data.payload.excludeBrandDiscount);
              this.normalStockForm
                .get("filtersInventory")
                .get("pricingTypeId")
                .setValue(response.data.payload.pricingTypeId);
              this.normalStockForm
                .get("filtersInventory")
                .get("mplDetailId")
                .setValue(response.data.payload.mplDetailId);
            } else {
              const option = {
                width: 300,
                displayTime: 5000,
                message: "No Price Found!",
                type: "error",
              };
              notify(option);
              console.error(response);
            }
          })
          .catch((error) => {
            this.loadingIndicator = false;
            const option = {
              width: 300,
              displayTime: 5000,
              message: error.message,
              type: "error",
            };
            console.log(error);
            notify(option);
          });
      }
    }
    if (
      customerBranchId &&
      itemCatalogGroupId &&
      this.normalStockForm.get("filtersInventory").get("isTranspose").value &&
      (sph || sph == 0) &&
      (cyl || cyl == 0 || addf || addf == 0)
    ) {
      let isCyl = false;
      let isAdd = false;
      // const item = this.itemCatalogList.find(
      //   (obj) => obj.itemIndex == this.normalStockForm
      //   .get("filtersInventory")
      //   .get("itemCatalogGroupId").value
      // );
      let customerId = this.customerList.find(
        (obj) => obj.customerBranchId == customerBranchId
      ).customerId;
      if (
        this.selectedItemGroup.itemTypeMasterId == 2 &&
        this.selectedItemGroup.focalId == 1
      ) {
        isCyl = true;
      }
      if (
        this.selectedItemGroup.itemTypeMasterId == 2 &&
        (this.selectedItemGroup.focalId == 2 ||
          this.selectedItemGroup.focalId == 3)
      ) {
        isAdd = true;
      }
      if (
        (customerBranchId &&
          itemCatalogGroupId &&
          (sph || sph == 0) &&
          isCyl &&
          (cyl || cyl == 0)) ||
        (isAdd && addf)
      ) {
        // this.getGroupSize();
        this.normalStockForm
          .get("filtersInventory")
          .get("unitPrice")
          .setValue("");
        this.priceLabel = "";
        this._salesService
          .getFnPrice(
            JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
            customerId,
            itemCatalogGroupId,
            this.selectedItemGroup.focalId,
            this.selectedItemGroup.brandMasterId,
            sph,
            cyl ? cyl : 0,
            addf ? addf : 0,
            this.selectedItemGroup.isBarcodeSingleSide
              ? this.selectedItemGroup.isBarcodeSingleSide
              : false,
            JSON.parse(localStorage.getItem("selectedCustomerBranch"))
              .companyBranchId
          )
          .then((response: any) => {
            if (response.data.completed && response.data.payload) {
              if (response.data.payload.price == 0) {
                const option = {
                  width: 300,
                  displayTime: 5000,
                  message: "Price not available for selected item!",
                  type: "warning",
                };
                notify(option);
                return;
              }
              this.normalStockForm
                .get("filtersInventory")
                .get("unitPrice")
                .setValue(response.data.payload.price);
              this.normalStockForm
                .get("filtersInventory")
                .get("uomId")
                .setValue(response.data.payload.uomId);
              this.priceLabel = response.data.payload.priceTypeName;
              this.normalStockForm
                .get("filtersInventory")
                .get("excludeBrandDiscount")
                .setValue(response.data.payload.excludeBrandDiscount);
              this.normalStockForm
                .get("filtersInventory")
                .get("pricingTypeId")
                .setValue(response.data.payload.pricingTypeId);
              this.normalStockForm
                .get("filtersInventory")
                .get("mplDetailId")
                .setValue(response.data.payload.mplDetailId);
            } else {
              const option = {
                width: 300,
                displayTime: 5000,
                message: "No Price Found!",
                type: "error",
              };
              notify(option);
              console.error(response);
            }
          })
          .catch((error) => {
            this.loadingIndicator = false;
            const option = {
              width: 300,
              displayTime: 5000,
              message: error.message,
              type: "error",
            };
            console.log(error);
            notify(option);
          });
      }
    }
  }
  /**
   * @name getFormValidationErrors
   * @return Validation Msg
   */
  getFormValidationErrors(form: FormGroup) {
    const result = [];
    Object.keys(form.controls).forEach((key) => {
      const controlErrors: ValidationErrors = form.get(key).errors;
      // const controlFilterErros: ValidationErrors = form.get('filtersInventory').errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((keyError) => {
          result.push({
            control: key.replace(/([a-z0-9])([A-Z])/g, "$1 $2"),
            error: keyError,
            value: controlErrors[keyError],
          });
        });
      }
    });
    Object.keys(
      (form.controls["filtersInventory"] as FormGroup).controls
    ).forEach((key) => {
      const controlFilterErros: ValidationErrors = form
        .get("filtersInventory")
        .get(key).errors;
      if (controlFilterErros) {
        Object.keys(controlFilterErros).forEach((keyError) => {
          result.push({
            control: key.replace(/([a-z0-9])([A-Z])/g, "$1 $2"),
            error: keyError,
            value: controlFilterErros[keyError],
          });
        });
      }
    });
    return result;
  }

  /**
   * @name totalAmount
   * @returns void
   */
  get totalAmount() {
    if (
      this.normalStockForm.get("filtersInventory").get("qty").value &&
      this.normalStockForm.get("filtersInventory").get("unitPrice").value
    ) {
      this.total =
        this.normalStockForm.get("filtersInventory").get("qty").value *
        this.normalStockForm.get("filtersInventory").get("unitPrice").value;
      return (
        this.normalStockForm.get("filtersInventory").get("qty").value *
        this.normalStockForm.get("filtersInventory").get("unitPrice").value
      );
    }
  }

  /**
   * @name onInitialized
   * @param
   * @description getItemBarCodeData function is fired on press enter
   * @returns void
   */
  onInitialized(e) {
    e.component.registerKeyHandler("enter", (ea) => {
      this.addToGrid(this.normalStockForm, "click");
    });
  }

  moveToAddItem(value) {
    if (value) {
      clearTimeout(this.addItemInverval);
      this.addItemInverval = setTimeout(() => {
        this.addItem.instance.focus();
      }, 300);
    }
  }
  /**
   * @name addDataToGrid
   * @param event
   * @param {type}
   */
  // addDataToGrid(event: any){
  //   console.log(event)
  //   if (event && event.code == 'Enter') {
  //     this.addToGrid(this.normalStockForm, 'click');
  //   }
  // }

  /**
   * @name addToGrid
   * @param {FormGroup}
   * @param {type}
   */
  addToGrid(form: FormGroup, eventType?: any) {
    if (form.invalid && eventType == "click") {
      this.allRequiredErrorShow = true;
      return false;
    }
    if (this.normalStockForm.get("filtersInventory").get("qty").value == 0) {
      const option = {
        width: 300,
        displayTime: 5000,
        message: "Qty must be greater than 0",
        type: "error",
      };
      notify(option);
      return;
    }
    this.allRequiredErrorShow = false;
    this.normalStockForm
      .get("filtersInventory")
      .get("itemCatalogGroupId")
      .setValue(
        this.selectedItemGroup ? this.selectedItemGroup.itemCatalogGroupId : 0
      );
    this.normalStockForm
      .get("filtersInventory")
      .get("isBarcodeSingleSide")
      .setValue(
        this.selectedItemGroup && this.selectedItemGroup.isBarcodeSingleSide
          ? this.selectedItemGroup.isBarcodeSingleSide
          : false
      );
    const sideName = this.lensSideList.find(
      (s) => s.lensSideId == form.value.filtersInventory.lensSideId
    );
    this.normalStockForm
      .get("filtersInventory")
      .get("sideName")
      .setValue(sideName.sideName);
    const size = this.sizeList.find(
      (s) => s.itemSizeId == form.value.filtersInventory.itemSizeId
    );
    this.normalStockForm
      .get("filtersInventory")
      .get("size")
      .setValue(size.itemSizeValue);

    let {
      viewItemCatalogId,
      sph,
      cyl,
      addf,
      uomId,
      itemCatalogGroupId,
      isBarcodeSingleSide,
    } = form.value.filtersInventory;
    const { focalId, itemCode, itemName } = this.selectedItemGroup;
    if (uomId) {
      // tslint:disable-next-line:no-var-keyword
      var { uomname } = this.uomsList.find((obj) => obj.uomid == uomId);
    }
    const displayObject = {
      ...form.value.filtersInventory,
      uomname,
      itemCode,
      itemName,
      isBarcodeSingleSide,
    };
    displayObject["isBarcodeSingleSide"] =
      form.value.filtersInventory.isBarcodeSingleSide;
    // let cyloradd = (cyl == 0 ? Number.isInteger(cyl) : cyl) ? cyl : addf;
    let cyloradd = (cyl == 0 ? cyl : cyl) ? cyl : addf;
    let queryParameters = `focalId=${focalId}&salesOrderTypeId=${form.value.salesOrderTypeId}&itemCatalogGroupId=${this.itemCatalogGroupId}&sph=${sph}&cylOradd=${cyloradd}`;
    if (this.stockLense.length > 0) {
      let stockItem = this.stockLense.find(
        (item) =>
          item.itemCatalogGroupId == itemCatalogGroupId &&
          item.lensSideId == form.value.filtersInventory.lensSideId &&
          item.sph == sph &&
          (focalId == 1 ? item.cyl == cyl : item.addf == addf)
      );
      if (stockItem) {
        this.saveSwal.swalOptions = {
          icon: "success",
          titleText:
            "Item # " +
            stockItem.itemCatalogGroupId +
            " already exits!. Do you want to update Qty?...",
          showConfirmButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        };
        this.saveSwal.fire().then((res: any) => {
          if (res && res.dismiss == "cancel") {
            this.loadingIndicator = true;
            let stockObject = {
              vendorItemCatalogId: 0,
              availableQty: form.value.filtersInventory.qty,
              ...displayObject,
            };
            this.stockLense.push(stockObject);
            this.stockLense.map((item, index) => {
              item["index"] = index;
              item["total"] = item.qty * item.unitPrice;
            });
            this.itemCatalogDropdown.blur();
            this.itemCatalogDropdown.focus();
            console.log(this.stockLense);
            if (this.stockLense.length > 0) {
              const smoothScrollConfig = {
                block: "start",
                inline: "nearest",
                behavior: "smooth",
              };
              // let el;
              // setTimeout(() => {
              //   if (this.gridScrollElement) {
              //     el = this.gridScrollElement.nativeElement;
              //     el.scrollIntoView();
              //   }
              // }, 1000);
            }
            this.loadingIndicator = false;
            this.resetAddGridItems();
            // return false;
          } else {
            let qty = this.stockLense[stockItem.index].qty;
            displayObject["qty"] = displayObject["qty"] + qty;
            this.stockLense.splice(stockItem.index, 1);
            this.loadingIndicator = true;
            let stockObject = {
              vendorItemCatalogId: 0,
              availableQty: form.value.filtersInventory.qty,
              ...displayObject,
            };
            this.stockLense.push(stockObject);
            this.stockLense.map((item, index) => {
              item["index"] = index;
              item["total"] = item.qty * item.unitPrice;
            });
            this.itemCatalogDropdown.blur();
            this.itemCatalogDropdown.focus();
            console.log(this.stockLense);
            if (this.stockLense.length > 0) {
              const smoothScrollConfig = {
                block: "start",
                inline: "nearest",
                behavior: "smooth",
              };
              // let el;
              // setTimeout(() => {
              //   if (this.gridScrollElement) {
              //     el = this.gridScrollElement.nativeElement;
              //     el.scrollIntoView();
              //   }
              // }, 1000);
            }
            this.loadingIndicator = false;
            this.resetAddGridItems();
          }
        });
        // const option = {
        //   width: 300,
        //   displayTime: 5000,
        //   message: "Item already added!",
        //   type: "error",
        // };
        // notify(option);
      } else {
        this.loadingIndicator = true;
        let stockObject = {
          vendorItemCatalogId: 0,
          availableQty: form.value.filtersInventory.qty,
          ...displayObject,
        };
        this.stockLense.push(stockObject);
        this.stockLense.map((item, index) => {
          item["index"] = index;
          item["total"] = item.qty * item.unitPrice;
        });
        this.itemCatalogDropdown.blur();
        this.itemCatalogDropdown.focus();
        console.log(this.stockLense);
        if (this.stockLense.length > 0) {
          const smoothScrollConfig = {
            block: "start",
            inline: "nearest",
            behavior: "smooth",
          };
          // let el;
          // setTimeout(() => {
          //   if (this.gridScrollElement) {
          //     el = this.gridScrollElement.nativeElement;
          //     el.scrollIntoView();
          //   }
          // }, 1000);
        }
        this.loadingIndicator = false;
        this.resetAddGridItems();
      }
    } else {
      //IF STOCK LENSE DETAIL EMPTY THEN EXCUTE
      this.loadingIndicator = true;
      let stockObject = {
        vendorItemCatalogId: 0,
        availableQty: form.value.filtersInventory.qty,
        ...displayObject,
      };
      this.stockLense.push(stockObject);
      this.stockLense.map((item, index) => {
        item["index"] = index;
        item["total"] = item.qty * item.unitPrice;
      });
      this.itemCatalogDropdown.blur();
      this.itemCatalogDropdown.focus();
      console.log(this.stockLense);
      if (this.stockLense.length > 0) {
        const smoothScrollConfig = {
          block: "start",
          inline: "nearest",
          behavior: "smooth",
        };
        // let el;
        // setTimeout(() => {
        //   if (this.gridScrollElement) {
        //     el = this.gridScrollElement.nativeElement;
        //     el.scrollIntoView();
        //   }
        // }, 1000);
      }
      this.loadingIndicator = false;
      this.resetAddGridItems();
    }
    this.resetTranstose();
    setTimeout(() => {
      this.itemCatalogDropdown.blur();
      this.itemCatalogDropdown.focus();
      this.normalStockForm.get("filtersInventory").get("qty").setValue(1);
    }, 50);
  }

  /**
   * @name removeStockLensItem
   * @return void
   */
  removeStockLensItem(index: number) {
    this.stockLense.forEach((item, i) => {
      if (item.index == index) {
        this.stockLense.splice(i, 1);
      }
    });
  }
  /**
   * @name validateZeroValue
   * @return void
   *  */

  validateZeroValue(controlName: string, value?: any) {
    const val = value;
    if ((val || val == 0) && val == 0) {
      this.normalStockForm
        .get("filtersInventory")
        .get(controlName)
        .setValue(null);
      return;
    } else {
      if (controlName == "qty") {
        this.moveToAddItem(val);
      }
    }
  }
  /**
   * @name onEditorPreparing
   * @description validate quantity
   */
  onEditorPreparing(e) {
    if (e.data.qty > 0) {
      e.data.total = e.data.qty * e.data.unitPrice;
      this.total = e.data.qty * e.data.unitPrice;
      this.customizeText({ value: e.data.total });
      this.stockLensGrid.instance.refresh();
    }
    return;
  }

  customizeText(e) {
    return e.value;
  }
  customizeUnit(e) {
    return "Total: ";
  }
  /**
   * @name validateQty
   * @return boolean
   * @description validation mpl price to price
   */
  validateQty(e: any) {
    // isSubmit = false;if (e.value || e.value == 0) {
    if (e.data.qty == 0 || !e.data.qty) {
      this.isSubmit = false;
      this.stockLensGrid.onRowValidating.hasError = true;
      return false;
    }
    if (e && e.data) {
      if (this.salesOrderId) {
        if (e.data.qty > 0 && e.data.stockIssueQuantity == 0) {
          this.isSubmit = true;
          this.stockLensGrid.onRowValidating.hasError = false;
          return true;
        }
        if (e.data.stockIssueQuantity > 0) {
          if (e.data.qty > e.data.stockIssueQuantity) {
            this.isSubmit = false;
            this.stockLensGrid.onRowValidating.hasError = true;
            return false;
          } else {
            this.isSubmit = true;
            return true;
          }
        } else {
          if (e.data.qty > 0) {
            this.isSubmit = true;
            this.stockLensGrid.onRowValidating.hasError = false;
            return true;
          } else {
            this.stockLensGrid.onRowValidating.hasError = true;
            this.isSubmit = false;
            return false;
          }
        }
      }
      if (!this.salesOrderId) {
        if (e.data.qty) {
          //  if (e.data.qty == 0) { return true; }
          if (e.data.qty > 0) {
            this.isSubmit = true;
            this.stockLensGrid.onRowValidating.hasError = false;
            return true;
          } else {
            this.stockLensGrid.onRowValidating.hasError = true;
            this.isSubmit = false;
            return false;
          }
        }
      }
    }
  }
  /**
   * @name filterClearValidate
   * @return validation reset
   */
  filterClearValidate() {
    this.normalStockForm
      .get("filtersInventory")
      .get("itemCatalogGroupId")
      .clearValidators();
    this.normalStockForm
      .get("filtersInventory")
      .get("brandMasterId")
      .clearValidators();
    this.normalStockForm
      .get("filtersInventory")
      .get("lensSideId")
      .clearValidators();
    this.normalStockForm.get("filtersInventory").get("uomId").clearValidators();
    this.normalStockForm.get("filtersInventory").get("qty").clearValidators();
    this.normalStockForm
      .get("filtersInventory")
      .get("unitPrice")
      .clearValidators();
    this.normalStockForm
      .get("filtersInventory")
      .get("itemSizeId")
      .clearValidators();

    this.normalStockForm
      .get("filtersInventory")
      .get("itemCatalogGroupId")
      .updateValueAndValidity();
    this.normalStockForm
      .get("filtersInventory")
      .get("brandMasterId")
      .updateValueAndValidity();
    this.normalStockForm
      .get("filtersInventory")
      .get("lensSideId")
      .updateValueAndValidity();
    this.normalStockForm
      .get("filtersInventory")
      .get("uomId")
      .updateValueAndValidity();
    this.normalStockForm
      .get("filtersInventory")
      .get("qty")
      .updateValueAndValidity();
    this.normalStockForm
      .get("filtersInventory")
      .get("unitPrice")
      .updateValueAndValidity();
    this.normalStockForm
      .get("filtersInventory")
      .get("itemSizeId")
      .updateValueAndValidity();
  }

  /**
   * @name generateJobOrderStockReport
   * @returns void
   * @description Generate Report
   */
  generateJobOrderStockReport(saleOrderId: number, isUpdate: boolean) {
    this._salesService
      .generateJobOrderStockReport(saleOrderId, isUpdate)
      .then((res: any) => {
        console.log("Report Successfully Generate");
      })
      .catch((error) => {
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }
  /**
   * @name setDefaultValue
   * @reutrn void
   * @description SET DEFAULT VALUE FOR FORM CONTROLS
   */
  setDefaultValue() {
    this.normalStockForm
      .get("salesOrderId")
      .setValue(this.salesOrderId ? this.salesOrderId : 0);
    this.normalStockForm.get("salesOrderDate").setValue(new Date());
    this.normalStockForm.get("customerId").setValue(this.customerId);
    this.normalStockForm.get("customerTypeId").setValue(1);
    this.normalStockForm.get("salesOrderTypeId").setValue(1);
    this.normalStockForm.get("isOurLens").setValue(false);
    this.normalStockForm.get("totalAmount").setValue(0);
    this.normalStockForm.get("companyBranchId").setValue(0);
    this.normalStockForm.get("urgencyTypeId").setValue(2);
    this.normalStockForm.get("isWaitforSample").setValue(false);
    this.normalStockForm.get("createdByBranchId").setValue(0);
    this.normalStockForm.get("addDateTime").setValue(new Date());
    this.normalStockForm
      .get("addUserId")
      .setValue(JSON.parse(localStorage.getItem("userData")).id);
    this.normalStockForm.get("updateDateTime").setValue(new Date());
    this.normalStockForm
      .get("updateUserId")
      .setValue(JSON.parse(localStorage.getItem("userData")).id);
    this.normalStockForm.get("active").setValue(true);
    // FILTERS DEFAULT VALUES
    this.normalStockForm
      .get("filtersInventory")
      .get("itemCatalogGroupId")
      .setValue(0);
    this.normalStockForm
      .get("filtersInventory")
      .get("brandMasterId")
      .setValue(this.brandsList[0].brandMasterId);
    this.normalStockForm
      .get("filtersInventory")
      .get("materialId")
      .setValue(this.allMaterials[0].materialId);
    this.normalStockForm
      .get("filtersInventory")
      .get("focalId")
      .setValue(this.focalIdsList[0].focalId);
    this.normalStockForm
      .get("filtersInventory")
      .get("isTranspose")
      .setValue(false);
    this.normalStockForm
      .get("filtersInventory")
      .get("itemCatalogGroupId")
      .setValue(0);
    this.normalStockForm.get("filtersInventory").get("lensSideId").setValue(3);
    this.normalStockForm.get("filtersInventory").get("itemSizeId").setValue(0);
    this.normalStockForm.get("filtersInventory").get("size").setValue(0);
    this.customerInformation.nativeElement.scrollIntoView();
    this.filterAllItemCatalogs();
  }

  /**
   * @name resetAddGridItems
   * @return void
   */
  resetAddGridItems() {
    this.normalStockForm.get("filtersInventory").get("sph").setValue(null);
    this.normalStockForm.get("filtersInventory").get("cyl").setValue(null);
    this.normalStockForm.get("filtersInventory").get("addf").setValue(null);
    this.normalStockForm.get("filtersInventory").get("axis").setValue(null);
    this.normalStockForm.get("filtersInventory").get("size").setValue(null);
    this.normalStockForm.get("filtersInventory").get("unitPrice").setValue(0);
    this.priceLabel = "";
    this.normalStockForm.get("filtersInventory").get("qty").setValue(0);
    this.normalStockForm
      .get("filtersInventory")
      .get("additionAmount")
      .setValue(0);
    this.normalStockForm.get("filtersInventory").get("uomId").setValue(0);
  }

  /**
   * @name removeValidator
   * @param {FormGroup} Form
   * @return void
   */
  removeValidator(form: any) {
    // tslint:disable-next-line:forin
    for (const field in form.controls) {
      // 'field' is a string
      let con = form.get(field); // 'control' is a FormControl
      con.clearValidators();
      con.updateValueAndValidity();
    }
  }

  /**
   * @name validateSalesOrder
   * @method POST
   * @return Promise
   * @description validation for dublicate sale order checking
   */

  validateSalesOrder(data) {
    return new Promise((resolve: any, reject: any) => {
      this.loadingIndicator = true;
      let saleLense = [];
      this.stockLense.forEach((object) => {
        saleLense.push({
          itemCatalogGroupId: object.itemCatalogGroupId,
          isTranspose: object.isTranspose ? object.isTranspose : false,
          lensSideId: object.lensSideId ? object.lensSideId : 0,
          sph: object.sph,
          cyl: object.cyl,
          addf: object.addf,
        });
      });
      const payload = {
        customerId: this.customerId,
        salesOrderLens: saleLense,
      };
      this._salesService
        .validateSalesOrder(payload)
        .then((response: any) => {
          if (response.data.completed) {
            this.loadingIndicator = false;
            // RESOLVE TRUE
            resolve("continue");
          } else {
            this.loadingIndicator = false;
            this.saveSwal.swalOptions = {
              icon: "error",
              titleText: response.data.message,
              showConfirmButton: true,
              confirmButtonText: "Yes",
              showCancelButton: true,
              cancelButtonText: "No",
              allowOutsideClick: false,
              allowEscapeKey: false,
            };
            this.saveSwal.fire().then((res: any) => {
              if (res.value) {
                // RESOLVE CONTINUE
                resolve("continue");
              } else {
                // RESOLVE FALSE AND NOT ROUTE
                resolve("reject");
              }
            });
          }
        })
        .catch((error) => {
          this.loadingIndicator = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: error.message,
            type: "error",
          };
          notify(option);
        });
    });
  }

  /**
   * @name saveSalesOrderLens
   * @description SUBMIT NORMAL SALE ORDER DATA
   * @return void
   */
  saveSalesOrderLens() {
    if (this.stockLensGrid.onRowValidating.hasError) {
      return;
    }
    // this.filterClearValidate();
    this.removeValidator(this.normalStockForm.get("filtersInventory"));

    if (this.stockLense.length > 0 && this.normalStockForm.invalid) {
      return;
    }

    this.validateSalesOrder(this.stockLense).then((res) => {
      if (res == "continue") {
        //console.log('data upload')
        this.savePayloadToServer();
      } else {
        // NOTHING CALL
        return;
      }
    });
  }
  get errorByQty() {
    if (this.stockLense && this.stockLense.length > 0) {
      this.stockLense.forEach((object) => {
        if (object.qty == 0) {
          this.lineError = new Error("Qty Error Line # " + object.index);
          return true;
        } else {
          this.lineError = "";
          return false;
        }
      });
    } else {
      return false;
    }
  }
  /**
   * @name savePayloadToServer
   * @returns saving data to server
   * @descript Sale order
   */
  savePayloadToServer() {
    this.loadingIndicator = true;
    this.hideSubmitBtn = true;
    let loggedInBranchId = JSON.parse(
      localStorage.getItem("selectedCustomerBranch")
    ).companyBranchId;
    const salesOrderLensArray = [];
    this.stockLense.forEach((object) => {
      console.log(object);
      salesOrderLensArray.push({
        salesOrderId: object.salesOrderId ? object.salesOrderId : 0,
        salesOrderLensId: object.salesOrderLensId ? object.salesOrderLensId : 0,
        itemCatalogGroupId: object.itemCatalogGroupId,
        vendorItemCatalogId: object.vendorItemCatalogId,
        mplDetailId: object.mplDetailId,
        excludeBrandDiscount: object.excludeBrandDiscount,
        pricingTypeId: object.pricingTypeId,
        lensSideId: object.lensSideId,
        isBarcodeSingleSide: object.isBarcodeSingleSide,
        companyId: JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
        sph: object.sph,
        cyl: object.cyl,
        addf: object.addf,
        axis: object.axis ? object.axis : 0,
        qty: object.qty,
        size: object.size,
        isTranspose: object.isTranspose,
        unitPrice: object.unitPrice,
        uomId: object.uomId,
        focalId: object.focalId,
        brandMasterId: object.brandMasterId,
        addDateTime: this.appCons.getDate(),
        addUserId: this.appCons.getUserId(),
        updateDateTime: this.appCons.getDate(),
        updateUserId: this.appCons.getUserId(),
        active: true,
      });
    });
    const payload = {
      isClient: true,
      salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
      // salesOrderDate: new Date(),
      salesOrderDate: this.appCons.getDate(),
      customerId: this.customerId,
      brandMasterId: 0,
      customerBranchId: this.normalStockForm.get("customerBranchId").value,
      customerContactId: this.normalStockForm.get("customerContactId").value,
      salesOrderTypeId: this.normalStockForm.get("salesOrderTypeId").value,
      // itemCatalogGroupId: 206,
      focalId: this.focalId,
      holdSalesOrder: true,
      isOurLens: false,
      companyId: JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
      patientName: this.normalStockForm.get("patientName").value,
      customerTypeId: this.normalStockForm.get("customerTypeId").value,
      urgencyTypeId: this.normalStockForm.get("urgencyTypeId").value,
      ponumber: this.normalStockForm.get("ponumber").value,
      partnerOrderNumber: this.normalStockForm.get("partnerOrderNumber").value,
      instruction: this.normalStockForm.get("instruction").value,
      isWaitforSample: false,
      remarks: this.normalStockForm.get("remarks").value,
      companyBranchId: loggedInBranchId,
      createdByBranchId: loggedInBranchId,
      totalAmount: this.total,
      salesOrderDetail: {
        salesOrderLens: salesOrderLensArray,
      },
      addDateTime: this.appCons.getDate(),
      addUserId: this.appCons.getUserId(),
      updateDateTime: this.appCons.getDate(),
      updateUserId: this.appCons.getUserId(),
      active: true,
    };
    console.log("payload", payload);
    this._salesService
      .addSalesOrderLens(payload, this.salesOrderId)
      .then((response: any) => {
        if (response.data.completed) {
          this.loadingIndicator = false;
          let msg = this.salesOrderId
            ? "edit successfully"
            : "added successfully";
          this.saveSwal.swalOptions = {
            icon: "success",
            titleText: "Sale Order # " + response.data.payload + " " + msg,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "Ok",
            allowOutsideClick: false,
            timer: null,
          };
          // GENERATE REPORT FUNCTION
          // this.generateJobOrderStockReport(
          //   payload.salesOrderId > 0
          //     ? payload.salesOrderId
          //     : response.data.payload,
          //   this.salesOrderId ? true : false
          // );
          // END
          this.saveSwal.fire().then((res: any) => {
            if (this.salesOrderId) {
              this.router.navigate(["./portal/sales/sales-inquiry/index"]);
              this.hideSubmitBtn = false;
            } else {
              this.normalStockForm.reset();
              // this.normalStockForm.get('urgencyTypeId').setValue(2);
              this.stockLense = [];
              this.sizeList = [];
              // isSubmit = true;
              this.setDefaultValue();
              this.hideSubmitBtn = false;
            }
          });
        } else {
          this.loadingIndicator = false;
          this.hideSubmitBtn = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
        }
      })
      .catch((error) => {
        this.loadingIndicator = false;
        this.hideSubmitBtn = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }
}
